import { defineComponent as _defineComponent } from 'vue';
import { SImageLazy } from '@strana-artw/ui-kit';
export default /*#__PURE__*/_defineComponent({
  __name: 'ErrorOutput',
  props: {
    title: {
      default: 'Возникли проблемы во время обработки запроса'
    },
    text: {
      default: 'Приносим извинения, мы уже знаем о проблеме и в скором времени ее решим.'
    },
    img: null
  },
  setup: function setup(__props) {
    return {
      __sfc: true,
      SImageLazy: SImageLazy
    };
  }
});